import PolicySectionHeading from "./PolicySectionHeading";

export default PolicySectionHeading;
